module.exports = __webpack_public_path__ + "static/media/A1-12-Vorggon-cod94.1226b5fe.png";